import React, { createContext, useContext, useState } from 'react';
import axios from 'axios';
import { BASE_URL } from '../../api';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(
    localStorage.getItem('user') === 'true' || false
  );
  

  const handleLogin = () => {
 const token =localStorage.getItem("token")
    localStorage.setItem('token', token);
    localStorage.setItem('user', true);
    setUser(true);
  };

  const handleLogout = () => {
   
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setUser(false);
  };
  return (
    <AuthContext.Provider value={{ user, handleLogin, handleLogout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useUserAuth = () => useContext(AuthContext);